import { AnaColumn } from "../forms-template.service";
import { createGridConfig, gridMultiple, gridMultipleCrm } from "./gridSettings/gridSettings";

const generic = [
  {
    dataField: 'id',
    dataType: '',
    caption: 'Codice',
    allowEditing: true,
    colWidth: '60'
  },
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '540'
  },
]

//Tabella lista contatti
export const CrmContattiGrid: AnaColumn[] = [

  {
    itemType: 'group',
    caption: 'Contatto - CRM',
    class: '',
    colCount: '1',
    data: [
      {
        type: 'buttonArray',
        dataField: "",
        hideOnEdit: true,
        width: 30,
        disabled: false,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        odataFilter: '',
        buttonArray: [
          /* {
            name: 'ProcedureDetailContatto',
            hint: 'Dettagli Procedure',
            icon: 'link',
            text: 'Dettagli Procedure',
            stylingMode: '',
            event: 'ProcedureDetailContatto',
            outPutValue: false,
            componentType: '',
            componentOutPut: '',
            related: [],
            disabled: false,
            class: 'customBtnCrm',
            accesskey: '',
            visible: true,
            mode: '',
          }, */
          {
            event: "sediContatto",
            name: "sediContatto",
            hint: "Sedi Contatto",
            icon: "bi bi-houses",
            class: 'customBtnCrm sediContatto'
          },
          {
            event: "filesList",
            name: "filesList",
            hint: "Lista File",
            icon: "bi bi-file-earmark",
            class: 'customBtnCrm filesList'
          },
          {
            event: "sendMail",
            name: "sendMail",
            hint: "Invia Mail",
            icon: "bi bi-envelope-arrow-up",
            class: 'customBtnCrm sendMail'
          },
          {
            event: "sendMessage",
            name: "sendMessage",
            hint: "Invia Messaggio",
            icon: "bi bi-chat-left-text",
            class: 'customBtnCrm sendMessagge'
          },
          {
            event: "showProcedure",
            name: "showProcedure",
            hint: "Visualizza Procedure",
            icon: "bi bi-disc produce_node_icon",
            class: 'customBtnCrm showProcedure'
          },
        ]
      },
      {
        type: 'buttonArray',
        colVisible: false,
        dataField: "censimento",
        caption: "Censimento",
        hideOnEdit: true,
        width: 30,
        disabled: false,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        odataFilter: '',
        buttonArray: [
          {
            event: "censimento",
            name: "censimento",
            hint: "Invia Censimento",
            icon: "bi bi-send",
            class: 'customBtnCrm censimento'
          },
        ]
      },

      {
        type: 'campo',
        dataField: 'Cod',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Codice ID',
        colAlignment: 'center',

      },
      {
        type: 'campoMultiData',
        width: '110px',
        dataField: 'statoCensimento',
        colVisible: true,
        hideOnEdit: true,
        caption: 'Stato censimento',
        dataType: 'object',
        allowFiltering: false,
        // colAlignment: 'center'
      },
      {
        type: 'campoMultiData',
        colWidth: '115px',
        dataField: 'tipoAttivita',
        colVisible: true,
        hideOnEdit: true,
        caption: 'Tipo Attività',
        dataType: 'object',
        allowFiltering: false,
      },
      {
        type: 'campoMultiData',
        width: '115px',
        dataField: 'statoContatto',
        colVisible: true,
        hideOnEdit: true,
        caption: 'Cliente',
        dataType: 'object',
        allowFiltering: false,
        // colAlignment: 'center'
      },
      {
        type: 'campo',
        dataField: 'Cod',
        colVisible: true,
        colWidth: '80px',
        dataType: 'number',
        caption: 'Cod',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'CodAss',
        colVisible: true,
        colWidth: '90px',
        dataType: 'string',
        caption: 'Ass.',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'RagSoc',
        colVisible: true,
        colWidth: 190,
        dataType: 'string',
        caption: 'Ragione Sociale',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'Ind',
        colVisible: true,
        dataType: 'string',
        caption: 'Indirizzo',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'civico',
        colVisible: true,
        dataType: 'string',
        caption: 'Civico',
        colAlignment: 'center',
        colWidth: 60,
      },

      {
        type: 'campo',
        dataField: 'Cap',
        colVisible: true,
        dataType: 'string',
        caption: 'CAP',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'id_localita',
        colVisible: true,
        dataType: 'string',
        caption: 'Comune',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        width: 100,
        allowFiltering: false,
        lista: {
          dataSource: 'comuni?$orderBy=nome',
          displayExpr: 'nome',
          valueExpr: 'id',
          static: false
        }
      },
      {
        type: 'campo',
        dataField: 'id_regione',
        colVisible: false,
        dataType: 'string',
        caption: 'Regione',
        allowFiltering: false,
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'regioni',
          displayExpr: 'nome',
          valueExpr: 'id',
          static: false
        }
      },

      {
        type: 'campo',
        dataField: 'id_provincia',
        colVisible: true,
        dataType: 'number',
        caption: 'Provincia',
        colAlignment: 'center',
        width: 60,
        editorType: 'dxSelectBox',
        allowFiltering: false,
        lista: {
          dataSource: 'province',
          valueExpr: 'id',
          displayExpr: 'sigla_automobilistica',
          wingap: false,
        }
        /*lookup:{
          dataSource: 'province',
          displayExpr: 'sigla_automobilistica',
          valueExpr: 'id',
          static:false,          
          colonne:[{                       
            dataField:'sigla_automobilistica',
            dataType: 'number',
            caption: 'Provincia'
          }]
        },*/
        /*lista: {
          dataSource: 'province',
          displayExpr: 'sigla_automobilistica',
          valueExpr: 'id',
          static: false
        }*/
      },

      {
        type: 'campo',
        dataField: 'PIva',
        colVisible: true,
        dataType: 'string',
        caption: 'Partita IVA',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'Cf',
        colVisible: true,
        dataType: 'string',
        caption: 'Codice Fiscale',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'ConsensoEmail',
        colVisible: false,
        dataType: 'boolean',
        trueText: 'S',
        falseText: 'N',
        editorType: 'dxCheckBox',
        caption: 'Consenso Email',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'CodAgente',
        colVisible: true,
        dataType: '',
        editorType: 'dxSelectBox',
        caption: 'Agente',
        allowFiltering: false,
        width: 190,
        lista: {
          dataSource: 'agenti',
          valueExpr: 'Cod',
          displayExpr: 'RagSoc1',
          wingap: false,
        }
      },
      // {
      //   type: 'campo',
      //   dataField: 'Disabilitato',
      //   colVisible: true,
      //   dataType: 'string',
      //   caption: 'Stato',
      //   colAlignment: 'center',
      //   width: 50,
      //   allowFiltering: false,
      //   lista: {
      //     dataSource: 'Disabilitato',
      //     valueExpr: 'id',
      //     displayExpr: 'descrizione',
      //     static: true,
      //   }
      // },

    ]
  },

]
//Form aggiunta modifica contatti
export const CrmContattiForm: AnaColumn[] = [
  {
    itemType: 'group',
    caption: 'Informazioni Generali',
    captionClass: 'informazioniGenerali',
    class: '',
    groupDataField: 'informazioniGenerali',
    colCount: "7",
    colGroup: 5,
    data: [
      {
        type: 'campo',
        dataField: 'Cod',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Codice ID',
        colAlignment: 'center',
        nCol: 4,
      },
      //!-----------------------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'CodAss',
        colVisible: true,
        dataType: 'string',
        caption: 'Codice Ass.',
        disableOnUpdate: false,
        readonly: false,
        colAlignment: 'center',
        class: 'crm_contatti_editor ',
        nCol: 3,
        // width: 80,
        // validation: [
        //   { type: "required", message: "Campo Codice Ass. obbligatorio" },
        // ],
      },
      {
        type: 'campo',
        dataField: 'codCli',
        colVisible: true,
        dataType: 'string',
        caption: 'Codice Cliente',
        colAlignment: 'center',
        class: 'crm_contatti_editor me-1 ',
        maxLength: 6,
        nCol: 4,
      },
      {
        type: 'campo',
        dataField: 'Fonte',
        visible: true,
        defaultValue: 1,
        dataType: 'number',
        editorType: 'dxSelectBox',
        class: 'crm_editor',
        caption: 'Fonte',
        nCol: 4,
        lista: {
          dataSource: 'tabella?tipo=22',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          wingap: false,
          static: false,
          showClearButton: true,
        }
      },

      // {
      //   type: 'campoSpecial',
      //   colVisible: false,
      //   disabled: false,
      //   dataField: 'Disabilitato',
      //   class: 'mt-2',
      //   dataType: "boolean",
      //   labelWidth: 85,
      //   editorType: 'dxCheckBox',
      //   caption: 'Stato',
      //   readonly: false,
      //   nCol: 3,
      // },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },

      //!-----------------------------------------------------------------------------

      {
        type: 'campo',
        dataField: 'stCliente',
        visible: true,
        dataType: 'number',
        editorType: 'dxSelectBox',
        class: 'crm_editor me-1',
        caption: 'Cliente',
        maxSize: 90,
        // required: true,
        // validation: [
        //   { type: "required", message: "Campo Cliente obbligatorio" },
        // ],
        lista: {
          isDefaultOption: false,
          dataSource: 'stCliente',
          searchEnable: false,
          valueExpr: 'key',
          displayExpr: 'value',
          static: true,
        }

      },
      {
        type: 'campo',
        dataField: 'stStatoContratto',
        visible: true,
        defaultValue: 1,
        placeHolder: '1',
        dataType: 'number',
        editorType: 'dxSelectBox',
        class: 'crm_editor me-1',
        caption: 'Stato Contratto',
        nCol: 3,
        lista: {
          dataSource: 'tabella?tipo=202',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          wingap: false,
          static: false,
          showClearButton: true,
        }
      },
      {
        type: 'campo',
        dataField: 'stTipologiaContratto',
        visible: true,
        defaultValue: 1,
        placeHolder: '1',
        dataType: 'number',
        editorType: 'dxSelectBox',
        class: 'crm_editor me-1',
        caption: 'Tipo Contratto',
        nCol: 3,
        lista: {
          dataSource: 'tabella?tipo=201',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          wingap: false,
          static: false,
          showClearButton: true,
        }
      },
      {
        type: 'campo',
        dataField: 'statoCommerciale',
        visible: true,
        dataType: 'number',
        editorType: 'dxSelectBox',
        class: 'crm_editor',
        caption: 'Stato',
        maxSize: 90,
        colAlignment: 'center',
        lista: {
          isDefaultOption: false,
          dataSource: '',
          searchEnable: false,
          valueExpr: 'key',
          displayExpr: 'value',
          static: true,
          showClearButton: true,
          items: [
            { key: 0, value: 'Offerta accettata' },
            { key: 1, value: 'Offerta non accettata' },
            { key: 2, value: 'Ordine ricevuto' },
            { key: 3, value: 'Ordine non ricevuto' }
          ]
        }

      },

      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      //!-----------------------------------------------------------------------------

      {
        type: 'campoSpecial',
        dataField: "is_produttore",
        dataType: "boolean",
        caption: "Produttore",
        editorType: "dxCheckBox",
        nCol: 2,
        labelWidth: 80,
        class: 'anagraficaProduttoreLabel'
      },
      {
        type: 'campoSpecial',
        dataField: "is_smaltitore",
        dataType: "boolean",
        caption: "Destinatario",
        editorType: "dxCheckBox",
        nCol: 2,
        labelWidth: 80,

      },
      {
        type: 'campoSpecial',
        dataField: "is_intermediario",
        dataType: "boolean",
        caption: "Intermediario",
        editorType: "dxCheckBox",
        nCol: 2,
        labelWidth: 80,

      },
      {
        type: 'campoSpecial',
        dataField: "is_trasportatore",
        dataType: "boolean",
        caption: "Trasp./Op.Logist.",
        editorType: "dxCheckBox",
        nCol: 2,
        labelWidth: 80
      },
      {
        type: 'campoSpecial',
        dataField: "is_consulente",
        dataType: "boolean",
        caption: "Consulente",
        editorType: "dxCheckBox",
        nCol: 2,
        labelWidth: 80
      },
      {
        type: 'campoSpecial',
        dataField: "tipoVettore",
        caption: "Tipo Vettore",
        maxLength: "1",
        maxSize: 2,
        hideOnEdit: false,
        disabled: true,
        editorType: 'dxSelectBox',
        nCol: 3,
        lista: {
          isDefaultOption: false,
          dataSource: 'tipoVettore',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        },
      },

      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },

      ///

      //-------------------------------------------------------------------------

      {
        type: 'campo',
        dataField: 'RagSoc',
        colVisible: true,
        dataType: 'string',
        caption: 'Ragione Sociale',
        class: 'crm_contatti_editor  me-2',
        nCol: 6,
        validation: [
          { type: "required", message: "Campo Ragione Sociale obbligatorio" },
        ]
      },
      {

        type: 'campo',
        dataField: 'PIva',
        colVisible: true,
        dataType: 'string',
        caption: 'Partita IVA',
        class: 'crm_contatti_editor  me-2',
        nCol: 2,
        button: {
          name: 'btnPIva',
          location: 'after',
          event: "btnPIva",
          hint: "ottieni le informazioni",
          icon: "glyphicon mdi mdi-file-search-outline",
          outPutValue: true
        }
      },
      {
        type: 'campo',
        dataField: 'Cf',
        colVisible: true,
        dataType: 'string',
        caption: 'Codice Fiscale',
        class: 'crm_contatti_editor',
        nCol: 2,
        button: {
          name: 'btnCf',
          location: 'after',
          event: "btnCf",
          hint: "ottieni le informazioni",
          icon: "glyphicon mdi mdi-file-search-outline",
          outPutValue: true
        }
      },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      //!-----------------------------------------------------------------------------

      {
        type: 'campo',
        dataField: 'Ind',
        colVisible: true,
        dataType: 'string',
        caption: 'Indirizzo',
        class: 'crm_contatti_editor me-2',
        nCol: 6,
      },
      {
        type: 'campo',
        dataField: 'civico',
        colVisible: true,
        dataType: 'string',
        caption: 'Civico',
        class: 'crm_contatti_editor  me-2',
        nCol: 2,
      },
      {
        type: 'campo',
        dataField: 'Frazione',
        colVisible: true,
        dataType: 'string',
        caption: 'Frazione',
        class: 'crm_contatti_editor',
        nCol: 2,
        colAlignment: 'center',
      },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      /* --------------------------------------------------------- */

      {
        type: 'campo',
        dataField: 'Cap',
        colVisible: true,
        dataType: 'string',
        caption: 'CAP',
        class: 'crm_contatti_editor me-2',
        nCol: 3,
        colAlignment: 'center',
      },
      {
        type: 'campoSpecial',
        dataField: 'id_localita',
        colVisible: true,
        dataType: 'string',
        caption: 'Comune',
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        autoClear: true,
        class: 'crm_contatti_editor me-2',
        nCol: 6,
        colAlignment: 'left',
        editorType: '',
        validation: [
          { type: "required", message: "Campo Comune obbligatorio" },
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          related: ['id_provincia|id_provincia', 'id_regione|id_regione', 'cap|Cap'],
          dataSource: 'comuni',
          service: '',
          autocomplete: false,
          caption: 'Lista Comune',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Comune',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            minSearch: 4,
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'id_regione',
                dataType: '',
                caption: 'Codice Regione',
                allowEditing: true,
                colVisible: false,
              },
              {
                dataField: 'id_provincia',
                dataType: '',
                caption: 'Codice Provincia',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'nome',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
              },
              {
                dataField: 'cap',
                dataType: '',
                caption: 'Cap',
                allowEditing: true,
              },
              {
                dataField: 'codice_catastale',
                dataType: '',
                caption: 'Codice Catastale',
                allowEditing: true,
                colVisible: false
              },
            ],
          },
        },
      },
      {
        type: 'campoSpecial',
        dataField: 'id_regione',
        colVisible: true,
        visible: false,
        dataType: 'grid',
        nCol: 6,
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        disabled: true,
        caption: 'Regione',
        class: 'crm_contatti_editor disabileVisibile',
        colAlignment: 'left',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          dataSource: 'regioni',
          service: '',
          autocomplete: false,
          caption: '',
          filterStatic: "",
          componentType: 'dynamicGrid',
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
          },
        },

      },

      {
        type: 'campoSpecial',
        dataField: 'id_provincia',
        colVisible: true,
        dataType: '',
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        autoClear: true,
        disabled: true,
        nCol: 4,
        caption: 'Provincia',
        class: 'crm_contatti_editor disabileVisibile ',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          dataSource: 'province',
          service: '',
          autocomplete: false,
          caption: '',
          filterStatic: "",
          componentType: 'dynamicGrid',
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
          },
        },

      },

      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      /* ------------------------------------------------------------ */
      {
        type: 'campoSpecial',
        dataField: 'CodAgente',
        colVisible: true,
        dataType: 'string',
        caption: 'Distributore ',
        disableOnUpdate: true,
        showClearButton: false,
        class: 'crm_contatti_editor me-2 ',
        nCol: 4,
        validation: [
          { type: "required", message: "Campo Distributore obbligatorio" },
        ],
        button: {
          name: 'inviaEmailAgente',
          hint: 'Invia Email',
          icon: 'bi bi-envelope-arrow-up',
          location: 'before',
          text: 'inviaEmailAgente',
          event: 'inviaEmailAgente',
        },
        dynamic: {
          valueExpr: 'Cod',
          queryString: '?stato=1',
          displayExpr: 'RagSoc1',
          related: ['Resp|Resp', 'Mail|MailResponsabile', 'Cell|CellResponsabile'],
          dataSource: 'agenti',
          service: '',
          autocomplete: false,
          caption: 'Lista Distributori',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Distributori',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 700,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'RagSoc1',
                dataType: '',
                colVisible: true,
                caption: 'Rag. Sociale',
                allowEditing: true,
              },
              {
                dataField: 'RagSoc2',
                dataType: '',
                colVisible: false,
                caption: 'Rag. Sociale 2',
                allowEditing: true,
              },
              {
                dataField: 'Resp',
                dataType: '',
                caption: 'Responsabile',
                allowEditing: true,
                colWidth: 160
              },
              {
                dataField: 'Loc',
                dataType: '',
                caption: 'Comune',
                allowEditing: true,
                colWidth: 90
              },
              {
                dataField: 'Prov',
                dataType: '',
                caption: 'Provincia',
                allowEditing: true,
                colWidth: 50
              },

            ],
          },
        },
      },
      {
        type: 'campoSpecial',
        dataField: 'Resp',
        colVisible: true,
        dataType: 'string',
        caption: 'Responsabile',
        colAlignment: 'left',
        showClearButton: false,
        disabled: true,
        class: 'disabileVisibile crm_contatti_editor',
        nCol: 3,
      },
      {
        type: 'campoSpecial',
        dataField: 'MailResponsabile',
        colVisible: true,
        dataType: 'string',
        caption: 'E-Mail',
        colAlignment: 'left',
        showClearButton: false,
        disabled: true,
        class: 'disabileVisibile crm_contatti_editor',
        nCol: 3,
      },
      {
        type: 'campoSpecial',
        dataField: 'CellResponsabile',
        colVisible: true,
        dataType: 'string',
        caption: 'Cellulare',
        colAlignment: 'left',
        showClearButton: false,
        disabled: true,
        class: 'disabileVisibile crm_contatti_editor',
        nCol: 3,
      },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      { type: 'empty', colSpan: 6 },
      //-------------------------------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'Annot2',
        colVisible: false,
        visible: false,
        dataType: 'string',
        editorType: "textAreaWithBtn",
        caption: 'Note',
        class: 'crm_contatti_editor',
        nCol: 10,
      },
      {
        type: 'simpleButton', dataField: "btnEstrattoConto",
        colVisible: false,
        class: 'mt-3',
        columnMinWidth: 100,
        labelWidth: 100,
        // nCol: 3,
        button: {
          text: 'Estratto Conto',
          name: "estrattoConto",
          event: "",
          type: "normal",
          class: '',
          hint: "Estratto Conto",
          icon: "glyphicon mdi mdi-bank"

        }
      },
      {
        type: 'simpleButton', dataField: "btnStampaContratto",
        colVisible: false,
        class: 'mt-3',
        columnMinWidth: 120,
        labelWidth: 120,
        // nCol: 3,
        button: {
          text: 'Stampa Contratto',
          name: "stampaContratto",
          event: "",
          type: "normal",
          class: '',
          hint: "Stampa Contratto",
          icon: "glyphicon mdi mdi-file",

        }
      },
      {
        type: 'simpleButton', dataField: "btnSmartKey",
        colVisible: false,
        class: 'mt-3',
        width: "100%",
        //columnMinWidth: 100,
        //labelWidth: 100,
        // nCol: 3,
        button: {

          text: 'Smart Key',
          name: "Smart Key",
          event: "",
          type: "normal",
          class: '',
          hint: "Genera Activation Key",
          icon: "glyphicon mdi mdi-key"

        }
      },
      {
        type: 'simpleButton', dataField: "btnDettagliProcedura",
        colVisible: false,
        class: 'mt-3',
        //columnMinWidth: 100,
        //labelWidth: 100,
        // nCol: 3,
        button: {
          text: 'Dettagli Procedure',
          name: "showProcedure",
          event: "PIPPO",
          type: "normal",
          class: '',
          hint: "Dettagli Procedure",
          icon: "bi bi-disc"
        }
      },
    ]
  },
  {
    itemType: "formTabbed",
    colGroup: 5,
    caption: 'Informazioni Cliente',
    captionClass: 'crmContattoInformazioniGenerali',
    groupDataField: 'crmContattoInformazioniGenerali',
    colCount: "1",
    configuration: {
      //alcuni input di new nica form
      disableEditForm: false,
      nCol: 1,
      remoteOperation: true,
      masterKey: 'Cod',
      filterEditor: '/$', //possibili filtri /$?Cod=[Cod]&&id=[id]
      queryString: '',
      service: 'crmContattoInformazioniGenerali',
      api: 'contatti',
      api_rest: true,
      toolbarTop: false,
      toolbarBottom: false,
      heightForm: undefined,
      CustomButtonSetForm: undefined,
      CustomButtonSetFormTop: undefined,
      widthForm: undefined,
      classe: '',
      nameSessionStorage: undefined,
      remoteService: false,
    },
    data: []
  },

  /* {
    itemType: 'group',
    caption: 'Procedure e Moduli',
    colCount: 1,
    colGroup: 10,
    groupDataField: 'procedureModuliContattoGroup',
    data: [

      {
        type: 'customComponent',
        dataField: 'procedureModuliContatto',
        visible: true,
        component: {
          nameComponent: 'CrmDettagliProcedureContattiComponent',
          name: 'procedureModuliContatto',
          configuration: {
            static: false,
            //input del componente da passare in dataToSend
            filterEditor: '/$',//# possibili filtri = /$?Cod=[Cod] -> /1?Cod=1 ecc...
            masterKey: 'Cod',
            queryString: '',//? sempre vuoto
            detailVisible: true,
            collassabile: false,
            btnTooltip: false,
            heightTree: 210,
            focusStateEnabled: true,
            dataSetKey: 'dataRelated'
          }
        }
      },
    ]
  },
 */


  {
    itemType: "formTabbed",
    colGroup: 10,
    colSpan: 10,
    caption: '',
    captionClass: 'CrmContattoExtra',
    groupDataField: 'CrmContattoExtra',
    configuration: {
      //alcuni input di new nica form
      disableEditForm: false,
      nCol: 1,
      remoteOperation: true,
      masterKey: 'Cod',
      filterEditor: '/$', //possibili filtri /$?Cod=[Cod]&&id=[id]
      queryString: '',
      service: 'CrmContattoExtra',
      api: 'contatti',
      api_rest: true,
      toolbarTop: false,
      toolbarBottom: false,
      heightForm: undefined,
      CustomButtonSetForm: undefined,
      CustomButtonSetFormTop: undefined,
      widthForm: undefined,
      classe: '',
      nameSessionStorage: undefined,
      remoteService: false,
    },
    data: []
  }
]

//api= sedi
//Tabella lista responsabili contatti
export const crmContattiSedeGrid: AnaColumn[] = [

  {
    configuration:
    {
      service: 'crmContattiSedeForm',
      api: 'sede',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      // helpDoc: 'Movimentidicaricoescaricorifiuti.html',
      queryString: '',
      formType: 'simple',
      queryFilter: [{
        key: 'Sede',
        value: 'Cod'
      },],
      /* heightForm:'800', */
      widthForm: 600,
      idTabRif: [],
      masterKey: 'Cod',
      nCol: "1",

      //ListaHP=H12&ListaHP=H2&ListaHP=H4&
    },

    itemType: "group",
    colCount: "1",
    class: "",
    caption: "CRM - Contatto Sede",
    data: [
      {
        type: 'button',
        dataField: "",
        hideOnEdit: true,
        width: 30,
        disabled: false,
        class: 'text-center',
        horizontalAlignment: 'center',
        colAlignment: 'center',
        button:
        {
          name: 'apriProcedure',
          hint: 'Dettagli Procedure',
          icon: 'bi bi-disc produce_node_icon',
          text: 'Dettagli Procedure',
          event: 'apriProcedure',
        },

      },

      {
        type: 'campo',
        dataField: 'Cod',
        colVisible: false,
        dataType: 'string',
        caption: 'Cod.',
        colAlignment: 'center',
      },

      {
        type: 'campo',
        dataField: 'CodiceContatto',
        colVisible: false,
        dataType: 'string',
        caption: 'Cod. Contatto',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'CodAss',
        colVisible: false,
        dataType: 'string',
        caption: 'CodAss',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'RagSoc',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Ragione Sociale',
        colAlignment: 'left',
      },

      {
        type: 'campo',
        dataField: 'Ind',
        colVisible: true,
        dataType: 'string',
        caption: 'Indirizzo',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'civico',
        colVisible: true,
        dataType: 'string',
        caption: 'Civico',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'Cap',
        colVisible: true,
        dataType: 'string',
        caption: 'CAP',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'id_localita',
        colVisible: true,
        dataType: 'string',
        caption: 'Comune',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        allowFiltering: false,

        lookup: {
          dataSource: 'comuni',
          valueExpr: 'id',
          displayExpr: 'nome',
          colonne: [{
            dataField: 'nome'
          }]
        }
      },
      {
        type: 'campo',
        dataField: 'id_provincia',
        colVisible: true,
        dataType: 'string',
        caption: 'Provincia',
        colAlignment: 'center',
        editorType: 'dxSelectBox',
        allowFiltering: false,
        lista: {
          dataSource: 'province',
          displayExpr: 'nome',
          valueExpr: 'id',
          static: false,
          costantValues: [],
        }
      },
      {
        type: 'campo',
        dataField: 'id_regione',
        colVisible: false,
        dataType: 'string',
        caption: 'Regione',
        allowFiltering: false,
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'regioni',
          displayExpr: 'nome',
          valueExpr: 'id',
          static: false,
          costantValues: [],
        }
      },

      {
        type: 'campo',
        dataField: 'Disabilitato',
        colVisible: false,
        dataType: 'boolean',
        trueText: '1',
        falseText: '0',
        editorType: 'dxCheckBox',
        caption: 'Bloccato',
        colAlignment: 'center',
      },

      {
        type: 'campoData',
        dataField: 'DataUltimoAggiornamento',
        colVisible: false,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: 'date',
        caption: 'Data Agg.',
        showClearButton: true,
        showDropDownButton: false,
        colAlignment: 'center',
      },
    ]
  },

];

export const crmContattiSedeForm: AnaColumn[] = [
  {
    itemType: 'group',
    caption: 'Informazioni Generali',
    class: '',
    groupDataField: 'InformazioniGenerali',
    colCount: 4,
    /*     colGroup: 8, */
    data: [
      {
        type: 'campo',
        dataField: 'Cod',
        disabled: true,
        visible: false,
        colVisible: false,
        dataType: 'string',
        caption: 'Cod.',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'CodiceContatto',
        colVisible: false,
        visible: false,
        disabled: true,
        dataType: 'string',
        caption: 'Cod. Contatto',
        colAlignment: 'center',
        showClearButton: false,
      },
      //------------------------------------------------------------------------------------------------
      /*       {
              type: 'simpleButton',
              colVisible: false,
              dataField: 'pulisciDatiForm',
              dataType: "",
              colSpan: 5,
              caption: 'Pulisci campi',
              helpText: 'Rimuovi informazioni luoghi',
              hideOnEdit: false,
              class: '',
              button: {
                text: 'Pulisci campi',
                name: 'pulisciDatiForm',
                type: 'text',
                location: 'after',
                event: "pulisciDatiForm",
                hint: "Rimuovi informazioni luoghi",
                icon: "info",
                outPutValue: true,
              }
      
            }, */
      {
        type: 'campo',
        dataField: 'CodAss',
        colVisible: true,
        visible: false,
        dataType: 'string',
        caption: 'CodAss',
        colAlignment: 'left',
        nCol: 5
      },
      {
        type: 'campo',
        dataField: 'RagSoc',
        colVisible: true,
        visible: false,
        disabled: true,
        showClearButton: false,
        class: 'disabileVisibile',
        dataType: 'string',
        caption: 'Ragione Sociale',
        colAlignment: 'left',
        nCol: 5
      },

      //------------------------------------------------------------------------------------------------------------
      // Indirizzo, Comune, Cap ___________________________________________________________________
      {
        type: 'campo',
        dataField: 'Ind',
        colVisible: true,
        dataType: 'string',
        class: 'crm_contatti_editor',
        caption: 'Indirizzo',
        colAlignment: 'left',
        nCol: 8,
        maxLength: 50,
        acceptOnlyCharacters: "/[a-zA-Z0-9()/.,:;'\\-s ]/",
        validation: [
          { type: "required", message: "Campo Indirizzo è obbligatorio" },
          { type: "pattern", value: "^[a-zA-Z0-9/().,:;'\\-s ]+$", message: "Il campo Indirizzo può avere solo lettere, punti e spazi" },
          { type: 'maxLength', value: 50, message: "Lunghezza massima campo Indirizzo superata" },
        ],
      },
      {
        type: 'campo',
        dataField: 'civico',
        colVisible: true,
        dataType: 'string',
        class: 'crm_contatti_editor',
        caption: 'Civico',
        colAlignment: 'left',
        nCol: 2,
        maxLength: 15,
        acceptOnlyCharacters: "/[a-zA-Z0-9/.,\\-s ]/"
      },
      { type: 'empty' },
      { type: 'empty' },
      /* ---------------------------------------------- */
      {
        type: 'campo',
        dataField: 'Frazione',
        colVisible: true,
        dataType: 'string',
        class: 'crm_contatti_editor',
        caption: 'Frazione',
        colAlignment: 'left',
        nCol: 10,
        maxLength: 45,
        acceptOnlyCharacters: "/[a-zA-Z.,\\-s ]/",
        validation: [
          { type: "pattern", value: "^[a-zA-Z.,\\-s ]+$", message: "Il campo Frazione può avere solo lettere e punti" },
          { type: 'maxLength', value: 45, message: "Lunghezza massima campo Frazione superata" },
        ],
      },

      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },

      {
        type: 'campoSpecial',
        dataField: 'id_localita',
        colVisible: true,
        dataType: 'string',
        class: 'crm_contatti_editor',
        caption: 'Comune',
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        nCol: 5,
        colAlignment: 'left',
        editorType: '',
        validation: [
          { type: "required", message: "Campo Comune è obbligatorio" },
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          costantValue: [],
          related: ['id_regione|id_regione', 'id_provincia|id_provincia', 'cap|Cap'],
          dataSource: 'comuni',
          service: '',
          autocomplete: false,
          caption: 'Lista Comune',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Comune',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'id_regione',
                dataType: '',
                caption: 'Codice Regione',
                allowEditing: true,
                colVisible: false,
              },
              {
                dataField: 'id_provincia',
                dataType: '',
                caption: 'Codice Provincia',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'nome',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
              },
              {
                dataField: 'cap',
                dataType: '',
                caption: 'Cap',
                allowEditing: true,
              },
              {
                dataField: 'codice_catastale',
                dataType: '',
                caption: 'Codice Catastale',
                allowEditing: true,
                colVisible: false
              },
            ],
          },
        },
      },
      {
        type: 'campo',
        dataField: 'Cap',
        colVisible: true,
        dataType: 'string',
        class: 'crm_contatti_editor',
        caption: 'CAP',
        colAlignment: 'left',
        nCol: 2,
        maxLength: 5,
        acceptOnlyCharacters: "/[0-9]/",
      },
      {
        type: 'campoSpecial',
        dataField: 'id_provincia',
        colVisible: true,
        dataType: '',
        class: 'crm_contatti_editor',
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        nCol: 3,
        caption: 'Provincia',
        colAlignment: 'left',
        dynamic: {
          valueExpr: 'id',
          queryString: '?id_regione=$id_regione',
          costantValue: [
            { key: 'id_regione', value: 'id_regione' }
          ],
          displayExpr: 'nome',
          dataSource: 'province',
          campoTabRif: 'id',
          service: '',
          autocomplete: false,
          caption: 'Lista Province',
          filterStatic: "",
          related: ['id_regione|id_regione'],
          componentType: 'dynamicGrid',
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 500,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,//per skip e top in query
            overrideDataSource: null,
            concatDataField: null,
          },
        },

      },
      { type: 'empty' },
      { type: 'empty' },

      // Regione ____________________________________________________________________
      {
        type: 'campo',
        dataField: 'id_regione',
        colVisible: true,
        visible: false,
        dataType: 'grid',
        nCol: 5,
        class: 'crm_contatti_editor',
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        caption: 'Regione',
        colAlignment: 'left',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          dataSource: 'regioni',
          service: '',
          autocomplete: false,
          caption: 'Lista Comune',
          filterStatic: "",
          componentType: 'dynamicGrid',
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
          },
        },
      },
    ]
  },
  /* {
    itemType: 'group',
    caption: 'Recapiti Sede',
    class: '',
    groupDataField: 'RecapitiSede',
    colCount: 1,
    data: [
      {
        type: 'customComponent',
        dataField: 'listaRecapiti',
        visible: true,
        caption: 'Recapiti Sede',
        component: {
          nameComponent: 'NicaAnagraficaComponent',
          name: 'listaRecapiti',
          configuration: {
            static: true,
            //input del componente da passare in dataToSend
            dataSetKey: 'myDsStatic',
            dataFieldToSend: 'listaRecapiti',
            dataFieldReletedForm: 'listaRecapiti',
            filterEditor: '/$',//# possibili filtri = /$?Cod=[Cod] -> /1?Cod=1 ecc...
            masterKey: 'Cod',
            queryString: '',//? sempre vuoto
            service: 'crmElencoRecapitiContattoForm',
            orientamento: "l", formato: "a4", modeEdit: "row",
            api: '',
            wingap: false,
            remoteOperations: false,
            isStatic: true,
            isDataStatic: true,
            paginate: false,
            pageSize: 100,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            isExportPDFAvailable: false,
            TextAddRowButton: 'Aggiungi Recapito',
            dxocolumnchooser: false,
            gridHeight: 250,
            //            gridWidth: 1510,
            dxoscrolling: "virtual", dxosorting: "multiple",
            ricerca: false,
          }
        }
      },
    ]
  }, */
  /* {
    itemType: 'group',
    caption: 'Extra',
    class: '',
    colCount: 1,
    colGroup: 2,
    data: [
      {
        type: 'campoData',
        dataField: 'DataUltimoAggiornamento',
        colVisible: true,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: 'date',
        showClearButton: true,
        showDropDownButton: false,
        caption: 'Data Aggiorn.',
        colAlignment: 'center',
        nCol: 10
      },
      {
        type: 'campo',
        dataField: 'Disabilitato',
        colVisible: true,
        dataType: 'boolean',
        trueText: '1',
        falseText: '0',
        editorType: 'dxCheckBox',
        caption: 'Disabilitato',
        colAlignment: 'center',
        nCol: 10
      },
      {
        type: 'campo',
        dataField: 'ConsensoEmail',
        colVisible: true,
        dataType: 'boolean',
        trueText: 'S',
        falseText: 'N',
        editorType: 'dxCheckBox',
        caption: 'Consenso Email',
        colAlignment: 'center',
        nCol: 10
      },

    ]
  }, */
  //Griglia recapiti contatto in pop up con form
  /* {
    itemType: "group", colCount: '1', colSpan: '1', caption: "Recapiti contatto Sede",
    data: [
      {
        showInColumnChooser: false,
        type: 'campoGriglia', labelVisible: false,
        dataField: 'listaRecapitiContatto',
        nCol: 10,
        colVisible: false,
        colSpan: 2,
        costantValue: [{
          key: 'CodiceContatto',
          value: 'Contatto',
        }, {
          key: 'Cod',
          value: 'Contatto',
        }],
        class: 'tabellaRecapitiCrm',
        formGrid: {
          service: 'crmElencoRecapitiContattoGrid',
          api: '',

          remoteOperation: false,
          queryString: '',
          isEditable: true,
          isEditableNewRow: true,
          isEditableEditRow: true,
          isEditableDeleteRow: true,
          showToolbarTop: true,
          showFilter: false,
          selectionRowMode: null,  // 'single' | 'detail' | 'multiple';
          idTable: '',
          isSearchable: true

        }
      }],
  }, */



]

export const crmElencoRecapitiContattoGrid: AnaColumn[] = [


  {
    configuration:
    {

      service: 'crmElencoRecapitiContattoForm',
      api: 'responsabilicontatti',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      // helpDoc: 'Movimentidicaricoescaricorifiuti.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'Cod',
      nCol: 1,
      /*       heightForm: 400, */
      widthForm: 500,
      toolbarTop: false,
      toolbarBottom: true,
      isPopUp: true,

    },
    itemType: 'group',
    caption: 'Responsabili Contatto',
    class: '',
    colCount: '4',
    data: [{
      type: 'campo',
      dataField: 'Cod',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'Cod.',
      colAlignment: 'center',
    },
    {
      type: 'campo',
      dataField: 'Sede',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'Sede',
      colAlignment: 'center',
    },
    {
      type: 'campo',
      dataField: 'Contatto',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'Contatto',
      colAlignment: 'center',
    },
    {
      type: 'campo',
      dataField: 'RagSoc',
      colVisible: true,
      visible: true,
      dataType: 'string',
      caption: 'Nome Cognome',
      colAlignment: 'left',
      colWidth: 190
    },
    {
      type: 'campo',
      dataField: 'Tipo',
      dataType: '',
      caption: 'Ruolo',
      colAlignment: 'left',
      width: 120,
      //editorType: 'dxSelectBox',
      validation: [
        { type: 'required', message: 'Campo obbligatorio' }
      ],
      lista: {
        keyExpr: 'id',
        Async: true,
        dataSource: 'tabella',
        queryString: '?tipo=8',
        valueExpr: 'id',
        displayExpr: 'descrizione',
        static: false,
        wingap: false,
        costantValues: [
          { key: 'tipo', value: 8 }
        ],
      }
    },
    {
      type: 'campo',
      dataField: 'Cell1',
      colVisible: true,
      dataType: 'string',
      caption: 'Telefono',
      colAlignment: 'center',
      colWidth: 90,
    },
    {
      type: 'campo',
      dataField: 'Cell2',
      colVisible: true,
      dataType: 'string',
      caption: 'Cellulare',
      colAlignment: 'center',
      colWidth: 90,
    },
    {
      type: 'campo',
      dataField: 'Mail',
      colVisible: true,
      dataType: 'string',
      caption: 'Email',
      colAlignment: 'left',
    },
    {
      type: 'campo',
      dataField: 'Annot',
      colVisible: true,
      dataType: 'string',
      caption: 'Annotazione',
      colAlignment: 'left',
    },


    ]
  }
]

export const crmElencoRecapitiContattoForm: AnaColumn[] = [
  {
    itemType: 'group',
    caption: 'Responsabili Contatto',
    class: '',
    colCount: '2',
    data: [{
      type: 'campo',
      dataField: 'Cod',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'Cod.',
      colAlignment: 'center',
    },
    {
      type: 'campo',
      dataField: 'Sede',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'Sede',
      colAlignment: 'center',
    },
    {
      type: 'campo',
      dataField: 'Contatto',
      colVisible: false,
      visible: false,
      dataType: 'string',
      caption: 'Contatto',
      colAlignment: 'center',
    },
    {
      type: 'campo',
      dataField: 'RagSoc',
      colVisible: true,
      visible: true,
      dataType: 'string',
      caption: 'Nome Cognome',
      colAlignment: 'left',
      class: 'crm_editor',
      nCol: 10,
      maxLength: 45,
      acceptOnlyCharacters: "/[a-zA-Z0-9.,'\\-s ]/",
      validation: [
        { type: "required", message: "Campo Nome Cognome è obbligatorio" },
        { type: "pattern", value: "^[a-zA-Z0-9.,'\\-s ]+$", message: "Il campo Nome Cognome può avere solo lettere, numeri, punti e spazi" },
        { type: 'maxLength', value: 45, message: "Lunghezza massima campo Nome Cognome superata" },
      ],
    },
    { type: 'empty' },
    {
      type: 'campo',
      dataField: 'Tipo',
      colVisible: true,
      visible: true,
      disableOnUpdate: true,
      dataType: 'string',
      caption: 'Ruolo',
      colAlignment: 'left',
      editorType: 'dxSelectBox',
      class: 'crm_editor',
      nCol: 10,
      dynamic: {
        valueExpr: 'id',
        queryString: '?tipo=8',
        displayExpr: 'descrizione',
        campoTabRif: 'id',
        dataSource: 'tabella',
        api_rest: true,
        service: '',
        autocomplete: false,
        caption: 'Lista Tipi',
        filterStatic: "",
        componentType: 'dynamicGrid',
        costantValue: [
          { key: 'tipo', value: 8 },
        ],
        buttonOption: {
          text: 'Lista',
          icon: 'glyphicon mdi mdi-playlist-plus',
          hint: 'Lista Tipi',
          name: 'Loc',
          location: 'after',
        },
        settingGrid: {
          api_rest: true,
          masterKey: 'id',
          keyUnique: '',
          wingap: false,
          mode: 'cell',
          selectionMode: 'single',
          remoteOperations: true,
          hoverStateEnabled: true,
          rowAlternationEnabled: true,
          repaintChangesOnly: true,
          showFilterSearch: false,
          allowUpdating: false,
          allowDeleting: false,
          allowAdding: true,
          height: 630,
          showColBlank: false,
          campoTabRif: '',
          searchAndSelect: true, //Cerca Valore e seleziona
          searchType: 'contains',
          width: 600,
          toolbarButtonsBottomLeft: null,
          toolbarButtonsBottomRight: [0],
          isOdata: false,
          overrideDataSource: null,
          concatDataField: null,
          colonne: [
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice',
              allowEditing: true,
              colVisible: false
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione',
              allowEditing: true,
            }
          ],
        },
      },
    },
    { type: 'empty' },
    {
      type: 'campo',
      dataField: 'Cell1',
      colVisible: true,
      dataType: 'string',
      caption: 'Telefono',
      colAlignment: 'left',
      nCol: 5,
      class: 'crm_editor',
    },
    {
      type: 'campo',
      dataField: 'Cell2',
      colVisible: true,
      dataType: 'string',
      caption: 'Cellulare',
      colAlignment: 'left',
      nCol: 5,
      class: 'crm_editor',
    },
    {
      type: 'campo',
      dataField: 'Mail',
      colVisible: true,
      dataType: 'string',
      caption: 'Email',
      colAlignment: 'center',
      nCol: 10,
      class: 'crm_editor',
    },
    { type: 'empty' },

    {
      type: 'campo',
      dataField: 'Annot',
      colVisible: true,
      editorType: 'dxTextArea',
      maxLength: 45,
      dataType: 'string',
      caption: 'Annotazione',
      colAlignment: 'left',
      nCol: 10,
      class: 'crm_editor',
      validation: [
        { type: 'maxLength', value: 45, message: "La lunghezza del campo Annotazione non può superare i 45 caratteri." },
      ],
    },
    { type: 'empty' },



    ]
  }
]

export const CrmContattoExtra: AnaColumn[] = [

  {
    itemType: "group",
    colCount: '1',
    colSpan: '2',
    class: 'mt-2',
    caption: "Stato Contratto",
    groupDataField: 'listaTipoContatto',
    data: [
      {
        type: 'customComponent',
        dataField: 'listaTipoContatto',
        visible: true,
        component: {
          nameComponent: 'NicaAnagraficaComponent',
          name: 'listaTipoContatto',
          configuration: {
            static: true,
            //input del componente da passare in dataToSend
            dataSetKey: 'myDsStatic',
            dataFieldToSend: 'listaTipoContatto',
            filterEditor: '/$',//# possibili filtri = /$?Cod=[Cod] -> /1?Cod=1 ecc...
            masterKey: 'id',
            queryString: '',//? sempre vuoto
            service: 'crmTagTipoContattoGrid',
            orientamento: "l", formato: "a4", modeEdit: "row",
            api: '',
            wingap: false,
            remoteOperations: true,
            isStatic: true,
            isDataStatic: true,
            paginate: false,
            pageSize: 100,
            gridHeight: 155,
            /*             gridWidth: 1510, */
            dxoscrolling: "virtual", dxosorting: "multiple",
            ricerca: false,
            isExportPDFAvailable: false,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            dxocolumnchooser: false,
          }
        }
      },
    ]
  },

  {
    itemType: "group",
    colCount: '1',
    colSpan: '2',
    class: 'mt-2',
    caption: "Diario attività",
    groupDataField: 'listaDiario',
    data: [
      {
        type: 'customComponent',
        dataField: 'listaDiario',
        visible: true,
        component: {
          nameComponent: 'NicaAnagraficaComponent',
          name: 'listaDiario',
          configuration: {
            static: true,
            //input del componente da passare in dataToSend
            dataSetKey: 'myDsStatic',
            dataFieldToSend: 'listaDiario',
            filterEditor: '/$',//# possibili filtri = /$?Cod=[Cod] -> /1?Cod=1 ecc...
            masterKey: 'id',
            elimina: false,
            queryString: '',//? sempre vuoto
            service: 'crmDiarioAttivitaGrid',
            orientamento: "l", formato: "a4", modeEdit: "row",
            api: '',
            costantValues: [
              { key: 'CodContatto', value: 'Cod' },
              { key: 'DataInserimento', value: new Date() },
              { key: 'UtenteCheInserisce', value: 'UtenteCheInserisce' }
            ],
            wingap: false,
            remoteOperations: false,
            isStatic: true,
            isDataStatic: true,
            paginate: false,
            pageSize: 100,
            gridHeight: 155,
            /*             gridWidth: 1510, */
            dxoscrolling: "virtual", dxosorting: "multiple",
            ricerca: false,
            isExportPDFAvailable: false,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            dxocolumnchooser: false,
          }
        }
      },
    ]
  },
  {
    itemType: "group",
    colCount: '1',
    colSpan: '2',
    class: 'mt-2',
    caption: "Recapiti Azienda",
    groupDataField: 'listaRecapitiContatto',
    data: [
      {
        type: 'customComponent',
        dataField: 'listaRecapitiContatto',
        visible: true,
        component: {
          nameComponent: 'NicaAnagraficaComponent',
          name: 'listaRecapitiContatto',
          configuration: {
            static: true,
            //input del componente da passare in dataToSend
            dataSetKey: 'myDsStatic',
            dataFieldToSend: 'listaRecapitiContatto',
            filterEditor: '/$',//# possibili filtri = /$?Cod=[Cod] -> /1?Cod=1 ecc...
            masterKey: 'Cod',
            queryString: '',//? sempre vuoto
            service: 'crmElencoRecapitiContattoGrid',
            orientamento: "l", formato: "a4", modeEdit: "row",
            api: '',
            wingap: false,
            remoteOperations: false,
            isStatic: true,
            isDataStatic: true,
            paginate: false,
            pageSize: 100,
            gridHeight: 155,
            /*             gridWidth: 1510, */
            dxoscrolling: "virtual", dxosorting: "multiple",
            ricerca: false,
            isExportPDFAvailable: false,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            dxocolumnchooser: false,
          }
        }
      },
    ]
  },

  {
    itemType: "group",
    colCount: '1',
    colSpan: '2',
    class: 'mt-2',
    caption: "Statistiche",
    groupDataField: 'listaStatitica',
    data: [
      {
        type: 'customComponent',
        dataField: 'listaStatitica',
        visible: true,
        component: {
          nameComponent: 'NicaAnagraficaComponent',
          name: 'listaStatitica',
          configuration: {
            static: true,
            //input del componente da passare in dataToSend
            dataSetKey: 'myDsStatic',
            dataFieldToSend: 'listaStatitica',
            filterEditor: '/$',//# possibili filtri = /$?Cod=[Cod] -> /1?Cod=1 ecc...
            masterKey: 'Cod',
            queryString: '',//? sempre vuoto
            service: 'crmTagContattoStatisticheGrid',
            orientamento: "l", formato: "a4", modeEdit: "row",
            editorType: 'franco',
            api: '',
            isExportPDFAvailable: false,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            dxocolumnchooser: false,
            wingap: false,
            remoteOperations: true,
            isStatic: true,
            isDataStatic: true,
            paginate: false,
            pageSize: 100,
            gridHeight: 155,
            /*             gridWidth: 1510, */
            dxoscrolling: "virtual", dxosorting: "multiple",
            ricerca: false,
          }
        }
      },
    ]
  },
  {
    itemType: "group",
    colCount: '1',
    colSpan: '2',
    class: 'mt-2',
    caption: "Rapporti Commerciali",
    groupDataField: 'listaRapportiCommerciali',
    data: [
      /*       {
              showInColumnChooser: false,
              type: 'campoGriglia', labelVisible: false,
              dataField: 'listaRapportiCommerciali',
              nCol: 10,
              colVisible: false,
              class: 'tabellaRecapitiCrm',
              colSpan: 2,
              formGrid: {
                service: 'crmTagContattoCommercialiGrid',
                api: '',
                remoteOperation: false,
                queryString: '',
                isEditable: true,
                isEditableNewRow: true,
                isEditableEditRow: true,
                isEditableDeleteRow: true,
      
                showToolbarTop: true,
                // tableHeight: 590,
                tableWidth: 1100,
                showFilter: false,
                selectionRowMode: null,  // 'single' | 'detail' | 'multiple';
                isSearchable: true
      
              }
            }, */
      {
        type: 'customComponent',
        dataField: 'listaRapportiCommerciali',
        visible: true,
        component: {
          nameComponent: 'NicaAnagraficaComponent',
          name: 'listaRapportiCommerciali',
          configuration: {
            static: true,
            //input del componente da passare in dataToSend
            dataSetKey: 'myDsStatic',
            dataFieldToSend: 'listaRapportiCommerciali',
            filterEditor: '/$',//# possibili filtri = /$?Cod=[Cod] -> /1?Cod=1 ecc...
            masterKey: 'Cod',
            queryString: '',//? sempre vuoto
            service: 'crmTagContattoCommercialiGrid',
            orientamento: "l", formato: "a4", modeEdit: "row",
            api: '',
            wingap: false,
            remoteOperations: true,
            isStatic: true,
            isDataStatic: true,
            paginate: false,
            pageSize: 100,
            gridHeight: 155,
            /*             gridWidth: 1510, */
            dxoscrolling: "virtual", dxosorting: "multiple",
            ricerca: false,
            isExportPDFAvailable: false,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            dxocolumnchooser: false,
          }
        }
      },
    ]
  },
  {
    itemType: "group",
    colCount: '1',
    colSpan: '2',
    class: 'mt-2',
    caption: "Rapporti Economici",
    groupDataField: 'listaRapportiEconomici',
    data: [
      /* {
        showInColumnChooser: false,
        type: 'campoGriglia', labelVisible: false,
        dataField: 'listaRapportiEconomici',
        nCol: 10,
        colVisible: false,
        class: 'tabellaRecapitiCrm',
        colSpan: 2,
        formGrid: {
          service: 'crmTagContattoEconomiciGrid',
          api: '',
          remoteOperation: false,
          queryString: '',
          isEditable: true,
          isEditableNewRow: true,
          isEditableEditRow: true,
          isEditableDeleteRow: true,

          showToolbarTop: true,
          // tableHeight: 590,
          tableWidth: 1100,
          showFilter: false,
          selectionRowMode: null,  // 'single' | 'detail' | 'multiple';
          isSearchable: true

        }
      }, */
      {
        type: 'customComponent',
        dataField: 'listaRapportiEconomici',
        visible: true,
        component: {
          nameComponent: 'NicaAnagraficaComponent',
          name: 'listaRapportiEconomici',
          configuration: {
            static: true,
            //input del componente da passare in dataToSend
            dataSetKey: 'myDsStatic',
            dataFieldToSend: 'listaRapportiEconomici',
            filterEditor: '/$',//# possibili filtri = /$?Cod=[Cod] -> /1?Cod=1 ecc...
            masterKey: 'Cod',
            queryString: '',//? sempre vuoto
            service: 'crmTagContattoEconomiciGrid',
            orientamento: "l", formato: "a4", modeEdit: "row",
            api: '',
            wingap: false,
            remoteOperations: true,
            isStatic: true,
            isDataStatic: true,
            paginate: false,
            pageSize: 100,
            gridHeight: 155,
            /*             gridWidth: 1510, */
            dxoscrolling: "virtual", dxosorting: "multiple",
            ricerca: false,
            isExportPDFAvailable: false,
            isExportDocxAvailable: false,
            isExportExcelAvailable: false,
            dxocolumnchooser: false,
          }
        }
      },
    ]
  },

]


export const CrmContattoSendEmail: AnaColumn[] = [

  {
    itemType: 'group',
    class: '',
    groupDataField: 'multi_form_select',

    colCount: 4,
    colSpan: 2,
    data: [
      {
        type: 'campoSpecial',
        dataField: "email_checked",
        class: 'me-3',
        dataType: "boolean",
        caption: "Hai un email ",
        editorType: "dxCheckBox",
        nCol: 3,
        defaultValue: '1',

      },
      {
        type: 'campoSpecial',
        class: 'crm_contatti_editor',
        dataField: 'isRole',
        colVisible: true,
        caption: 'Seleziona i ruoli',
        editorType: 'dxSelectBox',
        nCol: 7,
        lista: {
          dataSource: 'tabella?tipo=8',
          valueExpr: 'id',
          wingap: false,
          displayExpr: 'descrizione',
          showDropDownButton: false,
          isMultiple: false,

        }
      },
      { type: 'empty', colSpan: '4', },
    ],

  },


]

export const crmContattoInformazioniGenerali: AnaColumn[] = [
  {
    itemType: 'group',
    caption: 'Elementi Contatto',
    groupDataField: 'elementiContatto',
    class: '',
    colCount: "3",
    colGroup: 10,
    data: [

      {
        type: 'campo',
        dataField: 'Tel1',
        colVisible: true,
        dataType: 'string',
        caption: 'Telefono',
        class: 'crm_contatti_editor ',
        nCol: 3,
      },
      {
        type: 'campo',
        dataField: 'Tel2',
        colVisible: true,
        dataType: 'string',
        caption: 'Telefono 2',
        class: 'crm_contatti_editor ',
        nCol: 3,
        acceptOnlyCharacters: '/[0-9]/',
      },
      {
        type: 'campo',
        dataField: 'Tel3',
        colVisible: false,
        visible: true,
        dataType: 'string',
        caption: 'Telefono 3',
        class: 'crm_contatti_editor',
        nCol: 4,
      },
      /* --------------------------------------------------------------------- */
      {
        type: 'campo',
        dataField: 'Http',
        colVisible: true,
        dataType: 'string',
        caption: 'Sito Web',
        class: 'crm_contatti_editor',
        nCol: 10,
        button: {
          name: 'apriLink',
          hint: 'Apri Link',
          icon: 'bi bi-link-45deg',
          event: 'apriLink',
          disabled: false,
          visible: true,
        }
      },
      { type: 'empty' },
      { type: 'empty' },
      //-------------------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'social1',
        colVisible: true,
        dataType: 'string',
        caption: 'Link Profilo Linkedin',
        class: 'crm_contatti_editor',
        nCol: 5,
        button: {
          name: 'apriLink',
          hint: 'Apri Link',
          icon: 'bi bi-link-45deg',
          event: 'apriLink',
          disabled: false,
          visible: true,
        }
      },
      {
        type: 'campo',
        dataField: 'social2',
        colVisible: true,
        dataType: 'string',
        caption: 'Link Profilo Facebook',
        class: 'crm_contatti_editor',
        nCol: 5,
        button: {
          name: 'apriLink',
          hint: 'Apri Link',
          icon: 'bi bi-link-45deg',
          event: 'apriLink',
          disabled: false,
          visible: true,
        }
      },
      { type: 'empty' },
      { type: 'empty' },
      //-------------------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'Fax',
        colVisible: false,
        visible: true,
        dataType: 'string',
        caption: 'Pec Email',
        class: 'crm_contatti_editor',
        nCol: 10,
      },
      { type: 'empty' },
      { type: 'empty' },
      //-------------------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'Mail',
        colVisible: true,
        dataType: 'string',
        caption: 'Email',
        class: 'crm_contatti_editor',
        nCol: 10,
      },
      { type: 'empty' },
      { type: 'empty' },
      /* -------------------------------------------------------------------- */
      {
        type: 'campo',
        dataField: 'Tel3',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Skype',
        class: 'crm_contatti_editor',
        nCol: 10,
      },
      /* ------------------------------------------------------ */
      {
        type: 'campo',
        dataField: 'Annot1',
        colVisible: true,
        dataType: 'string',
        editorType: "textAreaWithBtn",
        caption: 'Note',
        class: 'crm_contatti_editor',
        nCol: 10,
      },
      { type: 'empty' },
      { type: 'empty' },
      /* -------------------------------------------------------------------- */
      {
        type: 'campo',
        dataField: 'Annot2',
        colVisible: true,
        visible: false,
        dataType: 'string',
        editorType: "dxTextArea",
        caption: 'Nota 2',
        class: 'crm_contatti_editor',
        nCol: 5,
      },
      //-------------------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'ConsensoEmail',
        colVisible: true,
        dataType: '',
        caption: 'Consenso Invio Email',
        class: 'me-2 crm_contatti_editor',
        editorType: 'dxSelectBox',
        nCol: 5,
        lista: {
          dataSource: '',
          valueExpr: 'id',
          displayExpr: 'name',
          static: true,
          selectFirstElement: false,
          isDefaultOption: false,
          showClearButton: true,
          items: [
            {
              id: 'N', name: 'Non Acconsento Invio Email',
            },
            {
              id: 'S', name: 'Acconsento Invio Email',
            },
          ]
        }
      },
      {
        type: 'campo',
        dataField: 'ConsensoInternet',
        colVisible: true,
        dataType: '',
        caption: 'Consenso Pubblicazione Internet',
        labelVisible: true,
        nCol: 5,
        class: 'crm_contatti_editor',
        editorType: 'dxSelectBox',
        lista: {
          dataSource: '',
          valueExpr: 'id',
          displayExpr: 'name',
          static: true,
          selectFirstElement: true,
          isDefaultOption: false,
          showClearButton: true,
          items: [
            {
              id: 0, name: 'Nessuna Risposta',
            },
            {
              id: 1, name: 'Acconsento Pubblicazione Internet',
            },
            {
              id: 2, name: 'Non Acconsento Pubblicazione Internet',
            },
          ]
        }
      },
      //----------------------------------------------------------------
      {
        type: 'campoData',
        dataField: 'DataUltimoAggiornamento',
        colVisible: true,
        visible: false,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        disableOnUpdate: true,
        readonly: true,
        dataType: 'date',
        showClearButton: true,
        showDropDownButton: false,
        caption: 'Data Aggiornamento',
        labelWidth: 110,
        nCol: 5,

      },
      { type: 'empty', colSpan: '4', },
      //----------------------------------------------------------------

    ]
  },
  {
    itemType: 'group',
    caption: 'Informazioni Bancarie',
    groupDataField: 'informazioniBancarie',
    class: '',
    colCount: "4",
    colGroup: 10,
    data: [
      {
        type: 'campoSpecial',
        dataField: 'id_banca',
        colVisible: true,
        dataType: 'string',
        caption: 'Banca',
        disableOnUpdate: true,
        class: 'crm_contatti_editor',
        nCol: 10,
        colAlignment: 'center',
        dynamic: {
          valueExpr: 'COD',
          queryString: '',
          displayExpr: 'DES',
          campoTabRif: 'COD',
          dataSource: 'banche',
          service: '',
          related: ['ABICAB|AbiCab'],
          autocomplete: false,
          caption: 'Lista Banche',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Banche',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'COD',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'COD',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'DES',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
                colWidth: 160
              },
              {
                dataField: 'IND',
                dataType: '',
                colVisible: false,
                caption: 'Indirizzo',
                allowEditing: true,
              },
              {
                dataField: 'LOC',
                dataType: '',
                caption: 'Comune',
                allowEditing: true,
                colWidth: 90
              },
              {
                dataField: 'PRO',
                dataType: '',
                caption: 'Provincia',
                allowEditing: true,
                colWidth: 50
              },
              {
                dataField: 'CAP',
                dataType: '',
                caption: 'CAP',
                allowEditing: true,
                colWidth: 50
              },

            ],
          },
        },
      },

      /*       {
              type: 'campo',
              dataField: 'Abi',
              colVisible: true,
              dataType: 'string',
              caption: 'Abi',
              colAlignment: 'left',
              nCol: 4
            },
            {
              type: 'campo',
              dataField: 'Cab',
              colVisible: true,
              dataType: 'string',
              caption: 'Cab',
              colAlignment: 'left',
              nCol: 2
            }, */

      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'Iban',
        colVisible: true,
        dataType: 'string',
        caption: 'Iban',
        class: 'crm_contatti_editor',
        nCol: 10,
      },
      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------------------

      {
        type: 'campo',
        dataField: 'AbiCab',
        colVisible: true,
        showClearButton: false,
        disabled: true,
        class: 'disabileVisibile crm_contatti_editor mtt-1 ',
        dataType: 'string',
        caption: 'Abi/Cab',
        nCol: 5,
        autoClear: true,
      },
      {
        type: 'campo',
        dataField: 'Cc',
        colVisible: true,
        dataType: 'string',
        caption: 'C/C',
        class: 'crm_contatti_editor mtt-1',
        nCol: 3,
      },
      {
        type: 'campo',
        dataField: 'Cin',
        colVisible: true,
        dataType: 'string',
        caption: 'Cin',
        class: 'crm_contatti_editor mtt-1',
        nCol: 2,
      },
      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------------------
      {
        type: 'campoSpecial',
        dataField: 'CodPagamento',
        colVisible: true,
        disableOnUpdate: true,
        dataType: 'string',
        caption: 'Condizione Pagamento',
        class: 'crm_contatti_editor',
        nCol: 10,
        dynamic: {
          valueExpr: 'COD',
          queryString: '',
          displayExpr: 'DES',
          campoTabRif: 'COD',
          //related: ['Resp|Resp'],
          //correlateDataField: 'Resp',
          dataSource: 'condizionipagamento',
          service: '',
          autocomplete: false,
          caption: 'Lista Distributori',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Tipo Pagamento',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'COD',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 700,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'COD',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'DES',
                dataType: '',
                colVisible: true,
                caption: 'Descrizione',
                allowEditing: true,
              },

            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },



      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------------------

    ]
  },
  {
    itemType: 'group',
    caption: 'Informazioni Sign Book',
    groupDataField: 'informazioniSignBook',
    class: '',
    colCount: "1",
    colGroup: 10,
    data: [
      {
        type: 'campo',
        dataField: 'nomeSignBook',
        colVisible: true,
        dataType: 'string',
        caption: 'Nome',
        class: 'crm_contatti_editor mtt-1',
        nCol: 10,
      },
      {
        type: 'campo',
        dataField: 'cognomeSignBook',
        colVisible: true,
        dataType: 'string',
        caption: 'Cognome',
        class: 'crm_contatti_editor mtt-1',
        nCol: 10,
      },
      {
        type: 'campo',
        dataField: 'cfSignBook',
        colVisible: true,
        dataType: 'string',
        caption: 'Codice Fiscale',
        class: 'crm_contatti_editor mtt-1',
        nCol: 10,
        maxLength: 16
      },
      // { type: 'empty' },
      // { type: 'empty' },
      // { type: 'empty' },
      {
        type: 'campo',
        dataField: 'mailSignBook',
        colVisible: true,
        dataType: 'string',
        caption: 'E-mail',
        class: 'crm_contatti_editor mtt-1',
        nCol: 10,
      },
      {
        type: 'campo',
        dataField: 'cellSignBook',
        colVisible: true,
        dataType: 'string',
        caption: 'Cellulare',
        class: 'crm_contatti_editor mtt-1',
        nCol: 10,
        maxLength: 13,
        acceptOnlyCharacters: '/[0-9]/',
        validation: [
          {
            type: "pattern",
            value: "^\\+39\\d{6,12}$",
            message: "Il campo Cellulare (sezione Informazioni Sign Book) deve iniziare con +39"
          }
        ]
      },
    ]
  },
]

export const crmStampaContrattoForm: AnaColumn[] = [
  {
    itemType: 'group',
    caption: 'Informazioni Sede Legale',
    captionClass: 'informazioniSedeLegale crmContattoInformazioniGenerali',
    class: 'mb-5',
    groupDataField: 'informazioniSedeLegale',
    colCount: "4",
    colSpan: 1,
    data: [
      {
        type: 'campo',
        dataField: 'RagSoc',
        dataType: '',
        caption: 'Ragione Sociale',
        nCol: 5,
        class: 'crm_contatti_editor me-2 ',
        validation: [
          { type: "required", message: "Il campo Ragione Sociale (Sede Legale) è obbligatorio." },
        ],
      },
      {
        type: 'campo',
        dataField: 'indSedeLegale',
        dataType: '',
        caption: 'Indirizzo',
        validation: [
          { type: "required", message: "Il campo Indirizzo (Sede Legale) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'provinciaSedeLegale',
        dataType: '',
        caption: 'Provincia',
        validation: [
          { type: "required", message: "Il campo Provincia (Sede Legale) è obbligatorio." },
        ],
        showDropDownButton: false,
        editorType: 'dxSelectBox',
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'locSedeLegale',
        dataType: '',
        caption: 'Località',
        validation: [
          { type: "required", message: "Il campo Località (Sede Legale) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'capSedeLegale',
        dataType: '',
        caption: 'Cap',
        maxLength: 5,
        acceptOnlyCharacters: "/[0-9]/",
        validation: [
          { type: "required", message: "Il campo Cap (Sede Legale) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'pIva',
        dataType: '',
        caption: 'Partita Iva',
        validation: [
          { type: "required", message: "Il campo Partita Iva (Sede Legale) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },

    ]
  },
  {
    itemType: 'group',
    caption: 'Informazioni Sede Operativa',
    captionClass: 'informazioniSedeOperativa crmContattoInformazioniGenerali',
    class: 'mb-5',
    groupDataField: 'informazioniSedeOperativa',
    colCount: "4",
    colSpan: 1,
    dataType: 'string',
    data: [
      {
        type: 'campoSpecial',
        dataField: 'personaDaContattare',
        colVisible: true,
        disabled: true,
        defaultValue: '',
        dataType: 'string',
        caption: 'Persona da contattare',
        disableOnUpdate: true,
        showClearButton: false,
        class: 'crm_contatti_editor me-2 ',
        nCol: 5,
        dynamic: {
          dataSource: 'responsabilicontatti',
          valueExpr: '',
          queryString: '?$filter=(Contatto eq $id) AND ((Sede eq 0) OR (Sede eq $codSede))',
          costantValue: [
            { key: 'id', value: 'id' },
            { key: 'codSede', value: 'codSede' }
          ],
          displayExpr: 'RagSoc',
          service: '',
          autocomplete: false,
          caption: 'Lista Responsabili',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Responsabili',
            name: 'responsabili',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            showColBlank: false,
            campoTabRif: '',
            searchType: 'contains',
            width: 900,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'RagSoc',
                dataType: '',
                colVisible: true,
                caption: 'Ragione Sociale',
                allowEditing: true,
                colWidth: 300
              },
            ],
          },
        },
      },

      {
        type: 'campo',
        dataField: 'indSpedizioneOp',
        disabled: true,
        dataType: '',
        caption: 'Indirizzo di spedizione',
        validation: [
          { type: "required", message: "Il campo Indirizzo di spedizione (Sede Operativa) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'frazioneOp',
        disabled: true,
        dataType: 'string',
        caption: 'Frazione',
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'provinciaOp',
        disabled: true,
        dataType: 'string',
        caption: '',
        visible: false
      },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'id_provincia',
        disabled: true,
        colVisible: true,
        dataType: 'number',
        caption: 'Provincia',
        colAlignment: 'center',
        nCol: 5,
        validation: [
          { type: "required", message: "Il campo Provincia (Sede Operativa) è obbligatorio." },
        ],
        showDropDownButton: false,
        class: 'crm_contatti_editor me-2 ',
        editorType: 'dxSelectBox',
        allowFiltering: false,
        lista: {
          dataSource: 'province',
          valueExpr: 'id',
          displayExpr: 'sigla_automobilistica',
          wingap: false,
          related: ['sigla_automobilistica|provinciaOp']
        }
      },
      {
        type: 'campo',
        dataField: 'locOp',
        disabled: true,
        dataType: '',
        caption: 'Località',
        validation: [
          { type: "required", message: "Il campo Località (Sede Operativa) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'capOp',
        disabled: true,
        dataType: '',
        caption: 'Cap',
        maxLength: 5,
        acceptOnlyCharacters: "/[0-9]/",
        validation: [
          { type: "required", message: "Il campo Cap (Sede Operativa) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },

    ]
  },
  {
    itemType: 'group',
    caption: 'Selezione Procedura',
    captionClass: 'selezioneProcedura crmContattoInformazioniGenerali',
    class: 'mb-5',
    groupDataField: 'selezioneProcedura',
    colCount: "4",
    colSpan: 1,
    data: [
      {
        type: 'campo',
        dataField: 'id',
        dataType: '',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'codiceContatto',
        dataType: 'string',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'codiceContatto0',
        dataType: 'string',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'codiceContatto1',
        dataType: 'string',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'codiceContatto2',
        dataType: 'string',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'codiceContatto3',
        dataType: 'string',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'codiceContatto4',
        dataType: 'string',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'codiceContatto5',
        dataType: 'string',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'codiceContatto6',
        dataType: 'string',
        caption: '',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'Sigla',
        dataType: '',
        caption: 'Sigla',
        validation: [
          { type: "required", message: "Il campo Sigla (Selezione Procedura) è obbligatorio." },
        ],
        nCol: 2,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campoSpecial',
        dataField: 'procedura',
        colVisible: true,
        dataType: '',
        caption: 'Procedure Attive ',
        disableOnUpdate: true,
        showClearButton: false,
        class: 'crm_contatti_editor me-2 ',
        nCol: 8,
        validation: [
          { type: "required", message: "La selezione della Procedura è obbligatoria." },
        ],
        dynamic: {
          dataSource: 'getAllProcedureByContatto',
          valueExpr: '',
          queryString: `/$id?procedura_attiva=1`,
          costantValue: [
            { key: 'id', value: 'id' }
          ],
          displayExpr: 'des',
          related: ['dataAttivazione|dataAttivazione', 'dataScadenza|dataScadenza',
            'dataInstallazione|dataInstallazioneProcedura', 'Sigla|Sigla',
            'moduli|moduli', 'Ind|indSpedizioneOp', 'CodSede|codSede', 'Licenza|Licenza',
            'Assistenza|Assistenza', 'quantita|quantita', 'rate|rate'

          ],
          service: '',
          autocomplete: false,
          caption: 'Lista Procedure',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Procedure',
            name: '',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'CodSede',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 900,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'CodSede',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'des',
                dataType: '',
                colVisible: true,
                caption: 'Descrizione',
                allowEditing: true,
                colWidth: 500
              },
              {
                dataField: 'Ind',
                dataType: '',
                colVisible: true,
                caption: 'Indirizzo',
                allowEditing: true,
                colWidth: 300
              },
              {
                dataField: 'dataAttivazione',
                dataType: '',
                colVisible: true,
                caption: 'Data Attivazione',
                allowEditing: true,
              },
              {
                dataField: 'dataScadenza',
                dataType: '',
                colVisible: true,
                caption: 'Data Scadenza',
                allowEditing: true,
              },
              {
                dataField: 'moduli',
                dataType: '',
                colVisible: false,
                caption: 'Moduli',
                allowEditing: true,
              },
              {
                dataField: 'Licenza',
                dataType: '',
                colVisible: false,
                caption: 'Licenza',
                allowEditing: true,
              },
              {
                dataField: 'Assistenza',
                dataType: '',
                colVisible: false,
                caption: 'Assistenza',
                allowEditing: true,
              },
              {
                dataField: 'quantita',
                dataType: '',
                colVisible: false,
                caption: 'quantita',
                allowEditing: true,
              },
              {
                dataField: 'rate',
                dataType: '',
                colVisible: false,
                caption: 'rate',
                allowEditing: true,
              }
            ],
          },
        },
      },
      {
        type: 'campoSpecial',
        dataField: 'codSede',
        visible: true,
        dataType: 'string',
        caption: '',
        disableOnUpdate: true,
        showClearButton: false,
        class: 'crm_contatti_editor me-2 d-none',
        nCol: 0,
        dynamic: {
          valueExpr: 'Cod',
          displayExpr: 'des',
          related: ['Ind|indSpedizioneOp', 'Cap|capOp', 'Loc|locOp', 'id_provincia|id_provincia', 'frazione|frazioneOp'],
          dataSource: 'sede',
          service: '',
          autocomplete: true,
          caption: 'Lista Procedure',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Procedure',
            name: '',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 900,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Ind',
                dataType: '',
                colVisible: true,
                caption: 'Indirizzo',
                allowEditing: true,
                colWidth: 300
              },
              {
                dataField: 'Cap',
                dataType: '',
                colVisible: true,
                caption: 'Cap',
                allowEditing: true,
                colWidth: 500
              },
            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campoData',
        dataField: 'dataInstallazioneProcedura',
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        caption: 'Data Installazione',
        class: 'crm_contatti_editor',
        validation: [
          { type: "required", message: "Il campo Data Installazione (Selezione Procedura) è obbligatorio." },
        ],
        nCol: 2,
        showDropDownButton: true
      },
      {
        type: 'campoData',
        dataField: 'dataAttivazione',
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        caption: 'Data Attivazione',
        class: 'crm_contatti_editor',
        validation: [
          { type: "required", message: "Il campo Data Attivazione (Selezione Procedura) è obbligatorio." },
        ],
        nCol: 2,
        showDropDownButton: true
      },
      {
        type: 'campoData',
        dataField: 'dataScadenza',
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        caption: 'Data Scadenza',
        class: 'crm_contatti_editor',
        validation: [
          { type: "required", message: "Il campo Data Scadenza (Selezione Procedura) è obbligatorio." },
        ],
        nCol: 2,
        showDropDownButton: true
      },
    ]
  },
  {
    itemType: 'group',
    caption: 'Informazioni Bancarie',
    captionClass: 'informazioniBancarie crmContattoInformazioniGenerali',
    class: 'mb-5',
    groupDataField: 'informazioniBancarie',
    colCount: "4",
    colSpan: 1,
    data: [
      {
        type: 'campo',
        dataField: 'cPag',
        dataType: '',
        caption: 'Condizione di pagamento',
        validation: [
          { type: "required", message: "Il campo Condizione di pagamento (Informazioni Bancarie) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'banca',
        dataType: '',
        caption: 'Istituto Bancario',
        validation: [
          { type: "required", message: "Il campo Istituto Bancario (Informazioni Bancarie) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      { type: 'empty', colSpan: 4 },
      {
        type: 'campo',
        dataField: 'abi',
        dataType: '',
        caption: 'Abi',
        maxLength: 5,
        acceptOnlyCharacters: "/[0-9]/",
        validation: [
          { type: "required", message: "Il campo Abi (Informazioni Bancarie) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'cab',
        dataType: '',
        caption: 'Cab',
        maxLength: 5,
        acceptOnlyCharacters: "/[0-9]/",
        validation: [
          { type: "required", message: "Il campo Cab (Informazioni Bancarie) è obbligatorio." },
        ],
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'cc',
        dataType: '',
        maxLength: 12,
        acceptOnlyCharacters: "/[0-9]/",
        caption: 'C/C',
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },
      {
        type: 'campo',
        dataField: 'cin',
        dataType: '',
        caption: 'Cin',
        maxLength: 2,
        nCol: 5,
        class: 'crm_contatti_editor me-2 '
      },

    ]
  },
]

export const crmInviaContrattoForm: AnaColumn[] = [
  {
    itemType: 'group',
    caption: '',
    captionClass: '',
    class: 'mb-5',
    groupDataField: 'inviaContratto',
    colCount: 1,
    colGroup: 10,
    colSpan: 10,
    data: [
      {
        type: 'campo',
        dataField: 'nome',
        dataType: '',
        caption: 'Nome',
        nCol: 10,
        class: 'crm_contatti_editor mtt-1',
        validation: [
          { type: "required", message: "Il campo nome è obbligatorio." },
        ],
      },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'cognome',
        dataType: '',
        caption: 'Cognome',
        nCol: 10,
        class: 'crm_contatti_editor mtt-1',
        validation: [
          { type: "required", message: "Il campo cognome è obbligatorio." },
        ],
      },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'cf',
        dataType: '',
        caption: 'Codice fiscale',
        nCol: 10,
        maxLength: 16,
        class: 'crm_contatti_editor mtt-1',
        validation: [
          { type: "required", message: "Il campo codice fiscale è obbligatorio." },
        ],
      },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'mail',
        dataType: '',
        caption: 'E-mail',
        nCol: 10,
        class: 'crm_contatti_editor mtt-1',
        validation: [
          { type: "required", message: "Il campo mail è obbligatorio." },
        ],
      },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'cell',
        dataType: '',
        caption: 'Cellulare',
        nCol: 10,
        class: 'crm_contatti_editor mtt-1',
        acceptOnlyCharacters: '/[0-9]/',
        maxLength: 13,
        validation: [
          { type: "required", message: "Il campo cellulare è obbligatorio." },
          {
            type: "pattern",
            value: "^\\+39\\d{6,12}$",
            message: "Il campo Cellulare deve iniziare con +39"
          }
        ]
      },
    ]
  }
]

export const crmExportMailForm: AnaColumn[] = [
  {
    itemType: 'group',
    class: '',
    // groupDataField: 'esportaEmail',
    colCount: 1,
    colSpan: 2,
    data: [
      {
        type: 'campo',
        dataField: 'mailAziendale',
        dataType: 'boolean',
        caption: 'E-mail Incluse',
        class: 'crm_contatti_editor',
        editorType: 'dxSelectBox',
        // labelWidth: 131,
        nCol: 5,
        lista: {
          dataSource: '',
          valueExpr: 'id',
          displayExpr: 'name',
          static: true,
          selectFirstElement: true,
          isDefaultOption: false,
          items: [
            {
              id: 1, name: 'E-mail Aziendali',
            },
            {
              id: 2, name: 'E-mail solo Responsabili',
            },
            {
              id: 3, name: 'Tutte le E-mail',
            },
          ]
        }
      },
      // {
      //   type: 'campo',
      //   dataField: 'mailAziendale',
      //   dataType: 'boolean',
      //   caption: 'Includi E-mail Aziendale',
      //   editorType: 'dxSwitchBox',
      //   labelWidth: 131,
      //   nCol: 5,
      //   switchBox: {
      //     defaultValue: true,
      //     trueValue: true,
      //     falseValue: false,
      //     switchedOnText: 'Si',
      //     switchedOffText: 'No',
      //     height: 24,
      //     width: 100
      //   }
      // },
      // {
      //   type: 'campoSpecial',
      //   dataField: "tipoRuolo",
      //   caption: "Tipo Ruolo",
      //   editorType: 'dxSelectBox',
      //   colWidth: 450,
      //   nCol: 5,
      //   lista: {
      //     dataSource: '',
      //     valueExpr: 'id',
      //     displayExpr: 'descrizione',
      //     static: true,
      //     wingap: false,
      //     isMultiple: true,
      //     items: []
      //   }
      // },
      {
        type: 'campoSpecial',
        dataField: "tipoRuolo",
        caption: "Tipo Ruolo",
        colVisible: true,
        class: 'crm_contatti_editor',
        nCol: 10,
        hideOnEdit: false,
        allowEditing: false,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'tabella?tipo=8',
          service: '',
          autocomplete: false,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          caption: "Lista Ruoli",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Ruoli',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Ruoli',
            name: 'ruoli',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'descrizione',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'multiple',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 350,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: false, // da valutare in futuro
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [22, 0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'descrizione',
                dataType: 'string',
                caption: 'Seleziona tutti i ruoli',
                allowEditing: true,
              },
            ],
          },
          // settingGrid: createGridConfig({
          //   ...gridMultiple,
          //   colonne: generic,
          // }),

        }
      }
    ],
  },
]